import { CommonZoomInIcon, IconBoxButton } from '@thefarmersfront/kitchen';

import styles from './ZoomableImagePreview.module.scss';

const ZoomableImagePreview = ({
  imageUrl,
  alt,
  onClickZoom,
}: {
  imageUrl: string;
  alt: string;
  onClickZoom: () => void;
}) => {
  return (
    <div className={styles['image-preview']}>
      <IconBoxButton
        color="secondary"
        className={styles['zoom-icon-button']}
        size="tiny"
        aria-label="이미지 크게 보기"
        onClick={onClickZoom}
      >
        <CommonZoomInIcon size={16} />
      </IconBoxButton>
      <img src={imageUrl} alt={alt} />
    </div>
  );
};

export default ZoomableImagePreview;
